module.exports = __webpack_public_path__ + "img/messi-name.ba781261.svg";